// Private
const fixDateForAllBrowsers = dateString => {
  if (typeof dateString !== 'string') {
    return dateString
  }
  return dateString.replace(/-/g, '/').replace(/T/g, ' ')
}

// Returns true for statuses
// cancelled, cancelled_in_trial and cancelled_in_presale
const cancelled = (status) =>
  status.split('_')[0] === 'cancelled'

// Public
const centToDecimal = int => (int / 100).toFixed(2)

const dateToLocale = (date, locale) => {
  if (!date) return 'N/A'

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return new Date(fixDateForAllBrowsers(date))
    .toLocaleDateString(locale, options)
}

const amountToCurrency = (amount, locale, currency) =>
  new Intl.NumberFormat(
    locale,
    {
      style: 'currency',
      currency: currency,
    },
  ).format(centToDecimal(amount))

const statusIsInactive = (status) =>
  ['cancelled', 'stopped'].includes(normalizeStatus(status))

const normalizeStatus = (status) => {
  if (cancelled(status)) {
    return 'cancelled'
  }

  return status
}

// A helper method that can be used to resolve a object path from a string
// E.g. resolvePath(obj, 'something.other_thing') will
// return the value of obj.something.other_thing
const objByStringKey = (obj, path, separator = '.') =>
  path.split(separator).reduce((prev, curr) => prev && prev[curr], obj)

const convertDate = (dateValue) => {
  if (!dateValue) {
    return null
  } else if (dateValue instanceof Date) {
    return dateValue
  } else if (typeof dateValue === 'string') {
    return Date.parse(dateValue)
  } else {
    return null
  }
}

const isCurrent = (checkDate) => {
  if (checkDate === null) return true

  const d1 = convertDate(checkDate)
  const d2 = new Date()

  return d1 >= d2
}

const keyRank = (keyType) => {
  switch (keyType) {
    case 'nfc':
      return 1
    case 'rfid':
      return 2
    default:
      return 3
  }
}

// A helper method that finds the current active keyType from a list of membership keys.
const currentActiveTypeFromKeys = (keys, keyType, latest = false) => {
  if (!keys) return

  const activeKeys = currentActiveKeys(keys, keyType)

  if (activeKeys.length < 1) return
  if (activeKeys.length === 1) return activeKeys[0]

  // There might be more than one valid key, so
  // we find the one that was activated last
  const sortedKeys = activeKeys.reduce((a, b) => a.valid_from > b.valid_from ? a : b)

  return latest ? sortedKeys[0] : sortedKeys
}

const currentActiveKeys = (keys, keyType = null) => {
  if (!keys) return

  let typedKeys
  if (keyType) {
    typedKeys = keys.filter(k => k.type === keyType && isCurrent(k.valid_to))
  } else {
    typedKeys = keys
  }

  return typedKeys.filter(k => isCurrent(k.valid_to)).sort((a, b) => keyRank(a.type) - keyRank(b.type))
}

const getDeviceType = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera
  const isAndroid = /android/i.test(ua)
  const isApple = /iPhone/i.test(ua)

  const isMobile = isAndroid || isApple

  return { isAndroid, isApple, isMobile }
}

export {
  amountToCurrency,
  centToDecimal,
  currentActiveTypeFromKeys,
  currentActiveKeys,
  dateToLocale,
  normalizeStatus,
  statusIsInactive,
  objByStringKey,
  getDeviceType,
}
